module.exports = __webpack_public_path__ + "img/staying-focused.f222d27a.png";